export default {
	hookPrefix: 'button',
};
